import { useSelector, useDispatch } from 'react-redux'
import { Switch } from '@headlessui/react'
import moment from 'moment'
import { 
    setARaceEventTrainingStartDate,
    setARaceEventDate,
    setARaceDeloadAfterEvent
} from 'redux/slices/generator'

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function ARaceInput() {

    const dispatch = useDispatch()

    const aRace = useSelector((state) => state.generator.inputs.aRace)

    const HandleARaceEventTrainingStartDateChange = (event) => dispatch(setARaceEventTrainingStartDate(event.target.value))
    const HandleARaceEventDateChange = (event) => dispatch(setARaceEventDate(event.target.value))
    const ToggleARaceDeloadAfterEventChange = () => dispatch(setARaceDeloadAfterEvent(!aRace.deloadAfterEvent))

    return (
        <div className="border-t border-l border-b border-gray-400">
            <div className="flex border-b border-gray-400 font-semibold bg-gray-50 text-sm">
                <div className="flex-1 p-2 border-r border-gray-400">Event Name</div>

                <div className="flex-1 p-2 border-r border-gray-400">Event Type</div>

                <div className="flex-1 p-2 border-r border-gray-400">Event Training Start Date</div>

                <div className="flex-1 p-2 border-r border-gray-400">Event Date</div>

                <div className="flex-1 p-2 border-r border-gray-400">Deload After Event</div>

                <div className="flex-1 p-2 border-r border-gray-400">Program End Date</div>
            </div>

            <div className="flex">
                <div className="flex-1 p-2 border-r border-gray-400">{aRace.name}</div>

                <div className="flex-1 p-2 border-r border-gray-400">{aRace.eventType}</div>

                <div className="flex-1 p-2 border-r border-gray-400">
                    <input
                        type="date"
                        name="eventTrainingStartDate"
                        id="eventTrainingStartDate"
                        placeholder="Event Training Start Date*"
                        value={aRace.eventTrainingStartDate}
                        onChange={HandleARaceEventTrainingStartDateChange}
                        className="w-full cursor-pointer"
                    />
                </div>

                <div className="flex-1 p-2 border-r border-gray-400">
                    <input
                        type="date"
                        name="eventDate"
                        id="eventDate"
                        placeholder="Event Date*"
                        value={aRace.eventDate}
                        onChange={HandleARaceEventDateChange}
                        className="w-full cursor-pointer"
                    />
                </div>

                <div 
                    className="flex-1 flex items-center justify-center p-2 border-r border-gray-400"
                    onClick={ToggleARaceDeloadAfterEventChange}
                >
                    <Switch
                        checked={aRace.deloadAfterEvent}
                        className={classNames(
                            aRace.deloadAfterEvent ? 'bg-orange-600' : 'bg-gray-200',
                            'relative inline-flex h-4 w-8 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-600 focus:ring-offset-2'
                        )}
                    >
                        <span className="sr-only">Use setting</span>
                        <span
                            aria-hidden="true"
                            className={classNames(
                                aRace.deloadAfterEvent ? 'translate-x-4' : 'translate-x-0',
                                'pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                            )}
                        />
                    </Switch>
                </div>

                <div className="flex-1 p-2 border-r border-gray-400">
                    {moment(aRace.programEndDate).format('MM/DD/YYYY')}
                </div>

            </div>
        </div>
    )
}